import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const holidayManagementColumns: GridColumnConfig[] = [
  {
    title: 'Holiday Name',
    field: 'holidayName',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Holiday Date',
    field: 'holidayDate',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Year',
    field: 'year',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Description',
    field: 'description',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'isActive',
    filter: 'boolean',
    searchable: true,
  },
];
